import { useEffect, useState } from 'react';
import { useOrganizationsShortQuery, useProgramListQuery } from '@common/cache';

export const useDataAnalysis = () => {
  const [tabIndex, setTabIndex] = useState(1);

  const [wlProgramId, setWlProgramId] = useState<string>('');
  const [wlOrgId, setWlOrgId] = useState<string>('');

  const [subProgramId, setSubProgramId] = useState<string>('');
  const [subOrgId, setSubOrgId] = useState<string>('');

  const { data: programOptions = [], isLoading: isProgramLoading } =
    useProgramListQuery();
  const { data: organizationOptions = [], isLoading: isOrganizationLoading } =
    useOrganizationsShortQuery();

  const handleChangeTab = (newIndex: number) => {
    setTabIndex(newIndex);
  };

  useEffect(() => {
    if (organizationOptions && organizationOptions.length > 0 && !wlOrgId) {
      setWlOrgId(organizationOptions[0].id);
    }

    if (organizationOptions && organizationOptions.length > 0 && !subOrgId) {
      setSubOrgId(organizationOptions[0].id);
    }
  }, [isOrganizationLoading]);

  useEffect(() => {
    if (programOptions && programOptions.length > 0 && !wlProgramId) {
      setWlProgramId(programOptions[0].id);
    }

    if (programOptions && programOptions.length > 0 && !subProgramId) {
      setSubProgramId(programOptions[0].id);
    }
  }, [isProgramLoading]);

  return {
    tabIndex,
    handleChangeTab,
    wlProgramId,
    wlOrgId,
    setWlProgramId,
    setWlOrgId,
    subProgramId,
    subOrgId,
    setSubProgramId,
    setSubOrgId,
    programOptions: programOptions.map(o => ({
      value: o.id,
      label: o.name,
    })),
    organizationOptions: organizationOptions.map(o => ({
      value: o.id,
      label: o.name,
    })),
  };
};
